import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60f9e53a")

_pushScopeId("data-v-60f9e53a")
const _hoisted_1 = { class: "images-frame" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result.files, (f, i) => {
      return (_openBlock(), _createBlock("div", {
        class: "image-frame",
        key: f.id
      }, [
        _createVNode("img", {
          class: "image",
          src: _ctx.base64[i],
          alt: ""
        }, null, 8, ["src"])
      ]))
    }), 128))
  ]))
})